
  <mb-dialog-body>
    <div class="mb-dialog-custom__body">
      <img [src]="information" class="information" />
      <img [src]="arrow" class="arrow" [ngClass]="arrowType" />
      <div class="text" i18n="@@modals_withfullprice">
        Ahora te mostramos el <b>precio final que vas a pagar</b>, con impuestos y tasas
        incluidos.
      </div>
    </div>
  </mb-dialog-body>

